import UploadLoader from './upload-loader';

export default UploadLoader;
